import React from 'react';
import { CreateIssueContext } from './createIssueContext/CreateIssueContext';
import CreatePaginationContext from 'components/common/withPagination/withPagination';
import Presentational from './presentational';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withIssueForm } from 'components/common/withIssueForm';
import { withProcessesData } from 'components/common/withProcessesData';
import { withInspectionTemplatesStore } from 'store/inspection';

const IssueTable: React.FC = () => {
  return (
    <CreateIssueContext>
      <CreatePaginationContext>
        <Presentational />
      </CreatePaginationContext>
    </CreateIssueContext>
  );
};

export default composeHOCs(
  withProcessesData,
  withIssueForm,
  withInspectionTemplatesStore
)(IssueTable);
